import React, { Fragment } from 'react';

import Helmet from 'react-helmet';
import { loaders } from '../utils/loaders';

import { NavLink, Outlet, useParams } from 'react-router-dom';
import Loading from '../components/Loading.jsx';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { userPermissions } from './UserDashboard';

export const useUser = (userId) => {
    const [inProgress, setInProgress] = React.useState(true);
    const [user, setUser] = React.useState({});
    const [sop, setSop] = React.useState([]);
    const [org, setOrg] = React.useState({});
    const [grids, setGrids] = React.useState({});

    const handleUserUpdate = (userData) => {
        setUser((user) => ({
            ...user,
            ...userData,
            pif_start_date: userData.pif_start_date ? userData.pif_start_date : '1977-05-25'
        }));
    };
    React.useEffect(() => {
        const load = async () => {
            try {
                let sopResp = [];
                let grids = {};
                let org = {};
                let userResp = await loaders.user.load(userId);
                setUser((user) => ({
                    ...user,
                    ...userResp,
                    pif_start_date: userResp.pif_start_date ? userResp.pif_start_date : '1977-05-25'
                }));
                try {
                    sopResp = await loaders.user_sop.load(userResp._id);
                } catch {
                    sopResp = [];
                }

                let orgId = userResp.netsuite_entity;

                if (!orgId) {
                    setInProgress(false);
                    return false;
                }

                try {
                    grids = await loaders.user_grids.load(orgId);
                } catch (error) {
                    grids = {};
                }
                try {
                    org = await loaders.org.load(orgId);
                } catch {
                    org = {};
                }

                setInProgress(false);
                setOrg(org);
                setGrids(grids);
                setSop(sopResp);
            } catch (error) {
                console.error(error);
                setInProgress(false);
                setUser(null);
                setOrg({
                    currency: 'USD'
                });
            }
        };

        load();
    }, [userId]);
    return { user, sop, grids, org, inProgress, handleUserUpdate };
};

const UserView = () => {
    const params = useParams();
    const session = useSelector((state) => state.session);
    const { user, sop, inProgress } = useUser(params.user_id);

    if (inProgress) {
        return <Loading />;
    }

    if (!inProgress && !user) {
        return (
            <div className="container">
                <h1>User Not Found</h1>
            </div>
        );
    }

    let isReadOnly = (session?.permissions || []).includes(userPermissions.READONLY) && session?._id !== user?._id;
    return (
        <Fragment>
            <Helmet title={user.email} />
            <nav className="sub-nav no-print">
                <NavLink
                    to={`/customer/${user._id}`}
                    className={({ isActive }) => classNames('index', { active: isActive })}
                    end
                >
                    {user.email}
                </NavLink>
                {!!sop.length && (
                    <NavLink
                        to={`/customer/${user._id}/sop`}
                        className={({ isActive }) => classNames({ active: isActive })}
                    >
                        SOP
                    </NavLink>
                )}
                {!isReadOnly && (
                    <NavLink
                        to={`/customer/${user._id}/addresses`}
                        className={({ isActive }) => classNames({ active: isActive })}
                    >
                        Addresses
                    </NavLink>
                )}
                <NavLink
                    to={`/customer/${user._id}/orders`}
                    className={({ isActive }) => classNames({ active: isActive })}
                >
                    Orders
                </NavLink>
                <NavLink
                    to={`/customer/${user._id}/carts`}
                    className={({ isActive }) => classNames({ active: isActive })}
                >
                    Carts
                </NavLink>
            </nav>

            <div className="container">
                <Outlet />
            </div>
        </Fragment>
    );
};

export default UserView;
